import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function getAnalistasEntrega(tp_id, user_id) {
  try {
    const response = await authHttp().get(routes.urlAnalistasEntrega, {
      params: { tp_id, user_id },
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getUsuariosElegiveis(user_id) {
  try {
    const response = await authHttp().get(routes.urlAnalistasEntregaUsuariosElegiveis, {
      params: { user_id },
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function cadastrarAnalista(user_id, registred_by) {
  try {
    const response = await authHttp().post(routes.urlAnalistasEntrega, {
      user_id,
      registred_by,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getVeiculosByTp(tp_id) {
  try {
    const response = await authHttp().get(routes.urlAnalistasEntregaVeiculos(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associarVeiculo(analista_entrega_id, vehicle_id) {
  try {
    const response = await authHttp().post(routes.urlAnalistasEntregaVeiculosAssociar, {
      analista_entrega_id,
      vehicle_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function desassociarVeiculo(analista_entrega_id, vehicle_id) {
  try {
    const response = await authHttp().delete(routes.urlAnalistasEntregaVeiculosAssociar, {
      data: { analista_entrega_id, vehicle_id },
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associarTodosVeiculos(analista_entrega_id, tp_id) {
  try {
    const response = await authHttp().post(routes.urlAnalistasEntregaTodosVeiculos, {
      analista_entrega_id,
      tp_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function desassociarTodosVeiculos(analista_entrega_id, tp_id) {
  try {
    const response = await authHttp().delete(routes.urlAnalistasEntregaTodosVeiculos, {
      data: { analista_entrega_id, tp_id },
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
